import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createService } from "../../api/apiServices";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء خدمة جديدة
 */
export function useCreateService() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createServiceMutate,
        isPending,
    } = useMutation({
        mutationFn: createService,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["services"] });
            navigate('/services');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create service");
        },
    });

    return {
        createServiceMutate,
        isPending,
    };
}